import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DatePickerModalComponent } from 'src/app/core/helper/components/date-picker-modal/date-picker-modal.component';
import { BaseModal } from 'src/app/core/models/classes/base-modal';
import { Message_Type } from 'src/app/core/models/enums/message-type';
import { DateTimeService } from 'src/app/core/services/date-time.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { ModalService } from 'src/app/core/services/modal.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { UtilsService } from 'src/app/core/services/utils.service';
import { PheromoneRequest } from '../../models/pheromone-lure';
import { ImageToolsService } from '../../services/image-tools.service';
import { PheromoneLureService } from '../../services/pheromone-lure.service';

@Component({
  selector: 'app-add-pheromone-lure',
  templateUrl: './add-pheromone-lure.component.html',
  styleUrls: ['./add-pheromone-lure.component.scss'],
})
export class AddPheromoneLureComponent extends BaseModal implements OnInit {
  @Input() changeDate: any;
  @Input() expireDate: any;
  @Input() deviceId: number;
  @Input() insectType: {
    id: number,
    value: string
  }
  @Input() logId: number = 0;
  bugList: Array<any> = [];
  @Input() id: number;
  chooseExpireDate: boolean = false;
  constructor(
    private modalService: ModalService,
    private imageToolsService: ImageToolsService,
    private pheromoneService: PheromoneLureService,
    private loadingService: LoadingService,
    private toastService: ToastService,
    private translateService: TranslateService,
    private dateTimeService: DateTimeService) {
    super();
    super._modalService = modalService;
  }


  ngOnInit() { }

  ionViewDidEnter() {
    this.imageToolsService.categoriesList.forEach(e => {
      this.bugList.push({ id: e.ClassId, value: this.translateService.instant("bug." + e.TagName), tagName: e.TagName });
    });
    if (!this.changeDate)
      this.changeDate = new Date();
    // if (!this.expireDate)
    //   this.expireDate = new Date();
  }
  changePheromoneType() {
    this.modalService.presentListModal({
      itemList: this.bugList,
      isMultiple: false,
      confirmBtnText: "general.confirm",
      isFullscreen: false,
      title: "pheromone-lure.bug-list",
      hasConfirmBtn: false,
      showSearchbar: true
    }).then(e => {
      e.modalObj.onDidDismiss().then(response => {
        if (response.role === "itemSelected") {
          let bug = response.data.selectedItem;
          this.insectType.id = bug?.id;
          this.insectType.value = bug.tagName;
        }
      });
    });
  }

  enterDate(type: string) {
    let date = new Date();
    if (type == "expireDate") {
      date = date;

    } else if (type == "changeDate") {
      date = this.changeDate;
    }
    this.modalService.presentModal({
      component: DatePickerModalComponent,
      componentProps: {
        date: date
      },
      options: ModalService.defaultOptionsTransparent
    }).then(modal => {
      modal.modalObj.onDidDismiss().then(res => {
        if (res.data != null) {
          if (res.role == "date-data") {
            if (type == "expireDate") {
              this.chooseExpireDate = true;
              this.expireDate = res.data;
            } else if (type == "changeDate") {
              this.changeDate = res.data;
            }
          }
        }

      });
    });
  }


  save() {
    let payload: PheromoneRequest = {
      ChangeDate: new Date(this.changeDate).toISOString(),
      DeviceId: this.deviceId,
      ExpireDate: this.expireDate ? new Date(this.expireDate).toISOString() : null,
      Id: this.logId ? this.logId : 0,
      InsectTypeId: this.insectType.id
    }

    this.loadingService.showLoading();
    // if (this.dateTimeService.isAfter(this.expireDate, this.changeDate)) {
    if (this.insectType.id) {
      if (this.dateTimeService.isBefore(payload.ChangeDate, payload.ExpireDate)){
        this.pheromoneService.savePheromone(payload).subscribe(e => {
          this.loadingService.hideLoading();
          if (e.IsSuccess) {
            this.toastService.PresentBasicToast({ message: this.translateService.instant("pheromone-lure.save-success"), duration: 3500, type: Message_Type.SUCCESS });
            this.modalService.dismissByModalId(this.id, true, "success");
          } else {
            if (e.ValidationErrors && e.ValidationErrors.length > 0) {
              this.toastService.PresentBasicToast({ message: this.translateService.instant("errors." + e.ValidationErrors[0]), duration: 3500, type: Message_Type.WARNING });
            } else if (e.Message) {
              this.toastService.PresentBasicToast({ message: this.translateService.instant("errors." + e.Message), duration: 3500, type: Message_Type.DANGER });
            }
          }
        });
      }else{
        this.loadingService.hideLoading();
        this.toastService.PresentBasicToast({ message: this.translateService.instant("pheromone-lure.date-err"), duration: 3500, type: Message_Type.WARNING });
      }
      
    } else {
      this.loadingService.hideLoading();
      this.toastService.PresentBasicToast({ message: this.translateService.instant("pheromone-lure.choose-insect-type"), duration: 3500, type: Message_Type.WARNING });
    }

    // } else {
    //   this.loadingService.hideLoading();
    //   this.toastService.PresentBasicToast({ message: this.translateService.instant("pheromone-lure.date-warning"), duration: 3000, type: Message_Type.WARNING })
    // }
  }

}
